import { render, staticRenderFns } from "./Empleados.vue?vue&type=template&id=6c96f944&scoped=true"
import script from "./Empleados.vue?vue&type=script&lang=js"
export * from "./Empleados.vue?vue&type=script&lang=js"
import style0 from "./Empleados.vue?vue&type=style&index=0&id=6c96f944&prod&scoped=true&lang=css"
import style1 from "./Empleados.vue?vue&type=style&index=1&id=6c96f944&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c96f944",
  null
  
)

export default component.exports